import { render, staticRenderFns } from "./TestView.vue?vue&type=template&id=f57ca088&scoped=true"
import script from "./TestView.vue?vue&type=script&lang=js"
export * from "./TestView.vue?vue&type=script&lang=js"
import style0 from "./TestView.vue?vue&type=style&index=0&id=f57ca088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57ca088",
  null
  
)

export default component.exports